import {
    Modal,
    ModalBody,
    ModalButtons,
    ModalContent,
    ModalHeader,
    ModalHeaderTitle,
} from "@ui/common/Modal"
import { Button, ButtonType } from "@ui/common/buttons/Button"
import React from "react"

export function MeterSyncModal({
    
    isVisible,
    onCancelClick,
    onCloseWithoutSyncClick,
    onPerformSyncClick
}: {
    isVisible: boolean
    onCancelClick: () => void
    onCloseWithoutSyncClick: () => void
    onPerformSyncClick: () => void
}): JSX.Element {
    return (
        <Modal useContentTag={true} isVisible={isVisible} isClosable={false}>
            <ModalContent>
                <ModalHeader>
                    <ModalHeaderTitle>Meter Sync</ModalHeaderTitle>
                </ModalHeader>
                <ModalBody>
                    The variance between the Smart Hub meter and the physical meter is outside the expected range. A
                    meter sync is recommended.
                </ModalBody>
                <ModalButtons>
                    <Button label={"Cancel"} onClick={onCancelClick} />
                    <Button
                        label={"Close Work Order Without Syncing"}
                        type={ButtonType.Text}
                        onClick={onCloseWithoutSyncClick}
                    />
                    <Button
                        label={"Perform Meter Sync Now"}
                        onClick={onPerformSyncClick}
                    />
                </ModalButtons>
            </ModalContent>
        </Modal>
    )
}